import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
} from "@mui/material";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

import { Consultant_Get_One_From_MongoDB } from "../../api/Consultant_Get_One_From_MongoDB";
import GetClientAddress from "../../../functions/GetClientAddress";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";

import { Get_All_From_MongoDB_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_With_Search_Prop_In_Array";

const ConsultantMaterials = () => {
  const { logoutConsultant } = ConsultantuseAuth();

  let Arr_Materials = [
    {
      Header: "Dropbox files, including portal training video",
      Link: "https://www.dropbox.com/scl/fo/ty62y97miqyu9253cih7w/AEteJZBfvQhsG8wGzs_JXBM?rlkey=nztzquvg4o527iiw454jszxqu&st=1gjp4b6m&dl=0",
      Topic: "DropBox",
    },
    {
      Header: "InvestIN Dates and Fees PDF 24-25",
      Link: "https://docsend.com/view/hq3n7q8x4mu85jzm",
      Topic: "Key documents",
    },
    {
      Header: "InvestIN Work Experience Programmes 19-24",
      Link: "https://docsend.com/view/8kn5gxktwmgs2kmj",
      Topic: "Key documents",
    },
    {
      Header: "Agent sales guide 2024-25 Global",
      Link: "https://docsend.com/view/yq7yacf4d6j8sgag",
      Topic: "Key documents",
    },
    {
      Header: "Map of programme venues",
      Link: "https://docsend.com/view/wg4s4njq9wcmda9e",
      Topic: "Key documents",
    },
    {
      Header: "InvestIN Summer Trailer 2025",
      Link: "https://docsend.com/view/qg4qb7a3mcbtd473",
      Topic: "Videos",
    },
    {
      Header: "The Best Way to Get Work Experience This 2025 Summer",
      Link: "https://www.youtube.com/embed/DtTz-ogyoR4",
      Topic: "Videos",
    },
    {
      Header: "The Ultimate Work Experience: Summer 2025 (for ages 15-18)",
      Link: "https://www.youtube.com/embed/kqqciQwyIp0",
      Topic: "Videos",
    },
    {
      Header: "How to Meet Professionals in Your Dream Job",
      Link: "https://www.youtube.com/embed/AACZCoRhiAw",
      Topic: "Videos",
    },
    {
      Header: "Get a Work Experience Qualification & UCAS points!",
      Link: "https://www.youtube.com/embed/vWWneFMcuxc",
      Topic: "Videos",
    },
  ];

  //Get a distinct list of topics from the materials
  let Arr_Topics = Arr_Materials.map((obj) => obj.Topic);
  Arr_Topics = [...new Set(Arr_Topics)];

  const BoxMINE = ({ Header, Link }) => {
    return (
      <div
        style={{
          width: "600px",
          height: "450px",
          margin: "5px",
          padding: "5px",
          fontSize: "30px",
        }}
      >
        <a href={Link || ""} title={Header}>
          <h3 style={{ fontsize: "18px", color: "#000000" }}>
            <u>{Header || ""}</u>
          </h3>
        </a>
        <iframe
          src={Link || "https://example.com"}
          allow="fullscreen"
          width="100%"
          height="80%"
        ></iframe>
      </div>
    );
  };

  return (
    <div>
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link
        rel="stylesheet"
        href="https://www.w3schools.com/lib/w3-theme-black.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />

      {/* <!-- Materials --> */}
      <div
        class="w3-row-padding w3-padding-64 w3-theme-l5 w3-center"
        id="Materials"
      >
        <h1>
          <b>
            <u>Materials</u>
          </b>
        </h1>

        {Arr_Topics.map((topic) => (
          <>
            <h2>
              <i>{topic}</i>
            </h2>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-around",
                backgroundcolor: "DodgerBlue",
              }}
            >
              {Arr_Materials.filter((obj) => obj.Topic === topic).map(
                (obj_material, index) => (
                  <BoxMINE
                    Header={obj_material.Header}
                    Link={obj_material.Link}
                  />
                )
              )}
            </div>
          </>
        ))}
      </div>

      {/* <!-- Footer --> */}
      <footer class="w3-container w3-padding-32 w3-theme-d1 w3-center">
        <h4>Follow Us</h4>
        <a
          class="w3-button w3-large w3-teal"
          href="https://www.facebook.com/@investineducation/"
          title="Facebook"
        >
          <i class="fa fa-facebook"></i>
        </a>
        <a
          class="w3-button w3-large w3-teal"
          href="https://twitter.com/investin_ed"
          title="Twitter"
        >
          <i class="fa fa-twitter"></i>
        </a>

        <a
          class="w3-button w3-large w3-teal"
          href="https://www.instagram.com/investin_education/?hl=en"
          title="Instagram"
        >
          <i class="fa fa-instagram"></i>
        </a>
        <a
          class="w3-button w3-large w3-teal w3-hide-small"
          href="https://uk.linkedin.com/company/investin"
          title="Linkedin"
        >
          <i class="fa fa-linkedin"></i>
        </a>
        <a
          class="w3-button w3-large w3-teal"
          href="https://investin.org/"
          title="Website"
        >
          <i class="fa fa-globe"></i>
        </a>
      </footer>
    </div>
  );
};

export default ConsultantMaterials;
